import SportBettingArticle from '@/models/SportBettingArticle'
import { each, find } from 'lodash'
import Api from '@/services/api'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    sportBettingArticleCreateAlert: '',
    sportBettingArticleCreateStatus: '',
    sportBettingArticleDetails: {},
    requestStatus: '',
    requestMsg: ''
  },

  mutations: {
    // setSportBettingArticleList (state, articles) {
    //   state.list = map(articles, article => {
    //     if (article instanceof SportBettingArticle) {
    //       return article
    //     } else {
    //       return new SportBettingArticle(article)
    //     }
    //   })
    // },

    setSportBettingArticleList (state, articles) {
      each(articles, record => {
        const exist = find(state.list, { id: record.id })
        if (!exist) {
          state.list.push(new SportBettingArticle(record))
        }
      })
    },

    clearList (state) {
      state.list = []
    },

    setSportBettingArticleListMeta (state, meta) {
      state.listMeta = meta
    },

    setSportBettingArticleCreateAlert (state, payload) {
      state.sportBettingArticleCreateAlert = payload.msg
      state.sportBettingArticleCreateStatus = payload.status
    },

    setSportBettingArticleDetails (state, payload) {
      state.sportBettingArticleDetails = payload
    },

    removeSportBettingArticleListItem (state, index) {
      state.list.splice(index, 1)
    },

    setNewTrendingSportBettingArticle (state, article) {
      const index = state.list.findIndex(o => o.id === article.id)
      state.list[index] = new SportBettingArticle(article)
    },

    removeMoreOrderIndex (state, article) {
      const index = state.list.findIndex(o => o.id === article.id)
      if (state.list[index]) state.list[index].more_order_index = null
    },

    setRequestStatus (state, payload) {
      state.requestMsg = payload.msg
      state.requestStatus = payload.status
    }
  },

  actions: {
    async getSportBettingArticles ({ commit }, params) {
      const query = SportBettingArticle.page(params.page || 1)
        .orderBy(params.sort)

      if (params.search) {
        query.where('searchTitle', params.search)
      }

      //   if (params.article_filter !== 'all') {
      //     query.where(params.article_filter, true)
      //   }

      // if (params.limit === 'all') {
      //   query.params({ limit: 'all' })
      // } else {
      //   query.limit(20)
      // }

      query.limit(20)


      if (params.categoryContainingId) {
        query.where('categoryContainingId', params.categoryContainingId)
      }

      const res = await query.get()

      commit('setSportBettingArticleList', res.data)
      commit('setSportBettingArticleListMeta', res.meta)
    },

    async delete ({ commit }, id) {
      await Api.delete(`admin/sport-bettings/${id}`)
        .then(response => {
          let payload = { msg: 'Record Deleted.', status: 'error' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async publish ({ commit }, id) {
      await Api.put(`admin/sport-bettings/${id}/republish`)
        .then(response => {
          let payload = { msg: 'Article published.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async unpublish ({ commit }, id) {
      await Api.put(`admin/sport-bettings/${id}/unpublish`)
        .then(response => {
          let payload = { msg: 'Article unpublished.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async updateOrder ({ commit }, params) {
      await Api.post(`admin/sport-bettings/reorder`, params)
        .then(response => {
          let payload = { msg: 'Order Updated.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },
  }
}
